import { initBurger } from './components/initBurger';
import { initScrollToAnchor } from './components/initScrollToAnchor';

window.addEventListener('DOMContentLoaded', handleOnLoad, false);

function handleOnLoad() {
    initBurger();
    initScrollToAnchor();
}
